// extracted by mini-css-extract-plugin
export default {"copy":"jfa-z","sizingCopy":"kfa-z","predictedSize":"lfa-z","recommendedFitContainer":"mfa-z","recommendedFitIcon":"nfa-z","recommendedFitText":"ofa-z"};